import messages from './cmsStandaloneCreate.json' with { type: 'json' };

export const cmsStandaloneCreateFi: Readonly<typeof messages> = messages;
